'use client'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Header from 'components/Header'
import TextStyles from 'components/TextStyles'
import { STRAPI } from 'config/apis'

const News = () => {
  let pathname = usePathname()
  const [article, setArticle] = useState()
  const [image, setImage] = useState()

  const getData = async () => {
    try {
      const req = await fetch(
        STRAPI.NEWS.replace('{slug}', pathname.split('/noticies/').pop())
      )
      const parsed = await req.json()
      const articleParsed = parsed.data.pop().attributes
      setArticle(articleParsed)
      const imgs = articleParsed.imagen.data?.attributes.formats
      setImage(imgs?.xlarge || imgs?.large || imgs?.medium)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    article && (
      <>
        <Header
          img={image?.url || article.imgWP}
          blur={image?.width < 1000}
          position={article.posicion}
        />
        <div className="mt-24">
          <TextStyles
            data={article.contenido}
            title={article.titulo}
            timestamp={new Date(article.fecha).toJSON()}
          />
        </div>
      </>
    )
  )
}

export default News
